const data = [
  {
    roles: [
      "Head of Commerce",
      "Director of IT",
      "Director of Digital Marketing",
      "Head of Sales",
    ],
    title: "Oracle Commerce Website",
    description:
      "Move business online and enrich the buying experience with data from your CRM and back-office systems. Oracle Commerce is a unified B2B and B2C ecommerce platform that makes your digital sales channels central to your company’s success by building personalized, online buyer experiences, innovating faster, and boosting sales.",
    image: "tbnail01.png",
    cta_text: "Learn more about Oracle Commerce",
    url: "https://www.oracle.com/cx/ecommerce/",
  },
  {
    roles: [
      "Head of Commerce",
      "Director of IT",
      "Director of Digital Marketing",
      "Head of Sales",
    ],
    title: "Constellation Research: Oracle Revamps Commerce",
    description:
      "Explore key market trends and how the right ecommerce solution can help you keep up with rapidly changing buying and selling expectations.",
    image: "tbnail02.png",
    cta_text: "Download the Report",
    url: "https://www.oracle.com/a/ocom/resources/cx-constellation-report-oracle-revamps-cx-commerce.pdf",
  },
];

export default data;
